import React from 'react';

export default function Snow({ density = 0.001, maxParticleSize = 1, fallSpeed = 0.7, windStrength = 0.3 }) {
	const canvasRef = React.useRef(null);
	const animationFrameRef = React.useRef(null);
	const particlesRef = React.useRef([]);
	const dprRef = React.useRef(1);

	const initializeCanvas = React.useCallback(() => {
		const canvas = canvasRef.current;
		if (!canvas) return;

		const parent = canvas.parentElement;
		if (!parent) return;

		const rect = parent.getBoundingClientRect();
		dprRef.current = Math.max(1, Math.min(2, window.devicePixelRatio || 1));
		canvas.width = Math.floor(rect.width * dprRef.current);
		canvas.height = Math.floor(rect.height * dprRef.current);
		canvas.style.width = rect.width + 'px';
		canvas.style.height = rect.height + 'px';

		const area = rect.width * rect.height;
		const targetCount = Math.max(40, Math.floor(area * density));
		const particles = [];
		for (let i = 0; i < targetCount; i++) {
			particles.push({
				x: Math.random() * canvas.width,
				y: Math.random() * canvas.height,
				size: 1 + Math.random() * maxParticleSize,
				speed: (0.3 + Math.random() * fallSpeed) * dprRef.current,
				drift: (Math.random() - 0.5) * windStrength * dprRef.current,
				opacity: 0.6 + Math.random() * 0.4
			});
		}
		particlesRef.current = particles;
	}, [density, maxParticleSize, fallSpeed, windStrength]);

	const renderFrame = React.useCallback(() => {
		const canvas = canvasRef.current;
		if (!canvas) return;
		const ctx = canvas.getContext('2d');
		if (!ctx) return;

		ctx.clearRect(0, 0, canvas.width, canvas.height);
		ctx.fillStyle = '#ffffff';
		ctx.save();

		for (const particle of particlesRef.current) {
			particle.y += particle.speed;
			particle.x += particle.drift + Math.sin(particle.y * 0.002) * 0.2 * dprRef.current;
			if (particle.y > canvas.height) {
				particle.y = -5 * dprRef.current;
				particle.x = Math.random() * canvas.width;
			}
			if (particle.x > canvas.width) particle.x = 0;
			if (particle.x < 0) particle.x = canvas.width;

			ctx.globalAlpha = particle.opacity;
			ctx.beginPath();
			ctx.arc(particle.x, particle.y, particle.size * dprRef.current, 0, Math.PI * 2);
			ctx.fill();
		}

		ctx.restore();
		animationFrameRef.current = requestAnimationFrame(renderFrame);
	}, []);

	React.useEffect(() => {
		initializeCanvas();
		animationFrameRef.current = requestAnimationFrame(renderFrame);

		const handleResize = () => {
			initializeCanvas();
		};
		window.addEventListener('resize', handleResize);

		return () => {
			if (animationFrameRef.current) cancelAnimationFrame(animationFrameRef.current);
			window.removeEventListener('resize', handleResize);
		};
	}, [initializeCanvas, renderFrame]);

	return (
		<canvas ref={canvasRef} className="absolute inset-0 pointer-events-none" />
	);
}



